import QuestionSetFactory from './QuestionSetFactory';

var questionSets = {};

export default {
    addQuestionSets: function addQuestionSets(metaDataObj) {
        angular.extend(questionSets, metaDataObj);
    },

    $get: ['TranslateService', function (TranslateService) {
        return QuestionSetFactory.create(questionSets, TranslateService.instant);
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-angular/QuestionSetService.js
// module id = 900
// module chunks = 0